<router-outlet></router-outlet>
<msc-manager-aside></msc-manager-aside>
